import moment from 'moment'
import _ from 'lodash'
import { apiConstants } from '../constants/apiConstants'

export function filterBasedOnDate(list, startDate, endDate) {
  if (startDate !== 0 && endDate !== 0) {
    return list.filter(item => {
      const modifiedDate = new Date(
        moment(item.modifiedDate, 'YYYY-MM-DD hh:mm:ss'),
      ).getTime()
      return modifiedDate >= startDate && modifiedDate <= endDate
    })
  }
  return list
}

export function filterBasedOnSize(list, minSize, maxSize) {
  const minSizeToBytes = minSize * apiConstants.OneGBInBytes
  const maxSizeToBytes = maxSize * apiConstants.OneGBInBytes

  return list.filter(
    item => item.size >= minSizeToBytes && item.size <= maxSizeToBytes,
  )
}

export function filterFileList(list, filterQueries) {
  return list.filter(item => {
    return _.every(filterQueries, function(value, key) {
      return item[key] === value
    })
  })
}

export function filterFileListBasedOnField(list, fieldName) {
  return list.filter(item => _.has(item, fieldName))
}

export function searchFileNameInList(list, searchValue) {
  const valueToBeSearched = searchValue.toLowerCase()
  return list.filter(item =>
    _.includes(item.fileName.toLowerCase(), valueToBeSearched),
  )
}

export function filterStringInArray(array, searchValue) {
  return array.filter(arr => _.includes(arr, searchValue.toLowerCase()))
}

export default {
  filterBasedOnDate,
  filterFileList,
  searchFileNameInList,
  filterBasedOnSize,
  filterFileListBasedOnField,
  filterStringInArray,
}
